import React from 'react';

const CommsAction = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.0002 3.47295H20.8502C20.6102 3.47295 20.4302 3.24295 20.4902 3.01295L21.1602 0.462948C21.2602 0.082948 20.7802 -0.167052 20.5202 0.132948L16.8202 4.50295C16.6202 4.74295 16.7902 5.11295 17.1002 5.11295H19.2502C19.4902 5.11295 19.6702 5.34295 19.6102 5.57295L18.9402 8.12295C18.8402 8.50295 19.3202 8.75295 19.5802 8.45295L23.3002 4.08295C23.4902 3.84295 23.3202 3.47295 23.0002 3.47295Z"
      fill="#787F88"
    />
    <path
      d="M18.34 22.0029H5.66C3.64 22.0029 2 20.3629 2 18.3429V5.66294C2 3.64294 3.64 2.00294 5.66 2.00294H14C14.55 2.00294 15 2.45294 15 3.00294C15 3.55294 14.55 4.00294 14 4.00294H5.66C4.74 4.00294 4 4.74294 4 5.66294V18.3529C4 19.2629 4.74 20.0029 5.66 20.0029H18.34C19.25 20.0029 20 19.2629 20 18.3429V12.0029C20 11.4529 20.45 11.0029 21 11.0029C21.55 11.0029 22 11.4529 22 12.0029V18.3429C22 20.3629 20.36 22.0029 18.34 22.0029Z"
      fill="#787F88"
    />
    <path
      d="M13.43 15.0029H8.10002C7.36002 15.0029 6.77002 14.4029 6.77002 13.6729V10.3429C6.77002 9.60295 7.36002 9.00294 8.10002 9.00294H13.43C14.17 9.00294 14.76 9.60294 14.76 10.3329V13.6629C14.77 14.4029 14.17 15.0029 13.43 15.0029Z"
      fill="#787F88"
    />
    <path
      d="M8.77002 14.0029V16.6729C8.77002 16.9729 9.20002 17.1129 9.42002 16.8829L12.1 14.0029H8.77002Z"
      fill="#787F88"
    />
  </svg>
);
export default CommsAction;
